module.exports = __webpack_public_path__ + "img/night-bottom-bg_in.d40f4b1e.png";